// extracted by mini-css-extract-plugin
export default {"particle":"Particle_particle__GaXt8"};